<template lang="html">
  <div class="container">
    <div class="wrapper">
      <div class="header-box">
        <i class="icon-fanhui iconfont icon"  @click="$router.go(-1)"></i>
        <input v-model="selectedProject.key" type="text" placeholder="请输入项目名" name="" value="">
      </div>
      <mt-index-list >
        <mt-index-section index=''>
          <mt-cell  v-for="(item,index) in listData" :title="item.name" :key="item.code" :index="item.name" @click.native="chooseProject(item.code,item.name)" ></mt-cell>
        </mt-index-section>
      </mt-index-list>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import axios from 'axios'
  import { IndexList, IndexSection, MessageBox, Search } from 'mint-ui';
  export default {
    data () {
      return {
        // value:'',
        selectedProject: {
          key: '',
        },
        listData: {},
        routeFrom: '',
        // relatedPro: {
        //   type: '1',
        // },
      }
    },
    components: {

    },
    watch: {
      $route: {
        handler () {
          this.routeFrom = this.$route.query.from
        },
        immediate: true
      },
      ['selectedProject.key'] (val) {
        this.selectedProject.key = val
        let page = 1
        this.$http.getProList(this.selectedProject, page).then(res => {
          this.listData = res.data.list//得到的数据列表
        })
      }
    },
    methods: {
getListData () {//获取列表数据
        let page = 1
        this.$http.getRelationPro(this.relatedPro, page).then(res => {
          this.relatedList = res.data.list//  获得数组列表
          this.pagiNation.current_page = res.data.pagination.current_page//当前页数
          this.pagiNation.last_page = res.data.pagination.last_page// 最后一页
        })
      },
      chooseProject (code, name) {
        MessageBox.confirm(`确认关注${name}`).then(action => {
          this.$router.push({ name: 'relatedproject', query: { code: code, name: name, type: '1' } })
          this.$http.addRelation(code).then(res => {
            if (res.errCode == 0) {
              MessageBox('提示', '添加关注成功')
              // this.getListData()


            } else {
              //错误提示信息
              MessageBox('提示', res.errMsg)
            }

          })
        }, cancel => {
          // MessageBox('提示', '取消')
        });


      },

    },

    created () {
      let page = 1
      this.$http.getProList(this.selectedProject, page).then(res => {
        this.listData = res.data.list//得到的数据列表
      })
    },

  }
</script>

<style lang="css" scoped>
  * {
    color: black;
    /*background: #212533;*/
    background: #fff;
  }
  .wrapper /deep/ .mint-indexsection-index {
    padding: 0;
  }
  .container,
  .wrapper {
    width: 100%;
    height: 100%;
  }
  .tagtxt {
    width: 40%;
    /*background: hsla(210, 66%, 54%, .2);*/
    background: #ccc;

    height: 2.5rem;
    border-radius: 6px;
    line-height: 2.5rem;
    text-align: center;
    float: left;
    margin-bottom: 2%;
  }
  .tagtxt:nth-child(odd) {
    margin-right: 8%;
    margin-left: 2%;
  }
  .tagtxt:nth-child(even) {
    margin-left: 8%;
    margin-right: 2%;
  }
  .hotbox {
    overflow: auto;
  }
  .hotbox h1 {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.5);
    padding: 10px;
  }

  .header-box {
    width: 100%;
    height: 1.5rem;
    line-height: 1.5rem;
    /*background: hsla(218, 17%, 31%, .2);*/
    /*background: #ccc;*/
    position: relative;
    border-bottom: 1px solid rgba(66, 75, 93, 0.5);
  }
  .header-box input {
    width: 86%;
    height: 1rem;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 5%;
    margin: auto;
    border-radius: 2px;
    /*background: rgba(66, 76, 93, .2);*/
    background: #f4f4f4;
    padding-left: 3%;
  }
  .icon-dropdown {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    font-size: 1.4rem;
    transform: rotate(90deg);
    background: #292d3b;
  }
  i_back {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/drillPage/relatedProject/ProList.vue